import { ThemeInput } from "./types.js";

let light: ThemeInput = {
  direction: "darken",
  colors: {
    "primary": [
      "#ffffff",
      "#e3ecff",
      "#c6daff",
      "#aac8ff",
      "#8fb6ff",
      "#76a3ff",
      "#5f91fc",
      "#4a7ff4",
      "#386ee7",
      "#2a5ed7",
      "#1e4ec2",
      "#1440aa",
      "#0c3290",
      "#072674",
      "#041a57",
      "#020f38",
      "#010419",
      "#000000"
    ],
    "secondary": [
      "#ffffff",
      "#fce6ea",
      "#faced6",
      "#f7b5c2",
      "#f29db0",
      "#ec859e",
      "#e36e8d",
      "#d8597d",
      "#ca456e",
      "#b93460",
      "#a42351",
      "#8e1643",
      "#770b36",
      "#5f0529",
      "#46031d",
      "#2d0210",
      "#130104",
      "#000000"
    ],
    "info": [
      "#ffffff",
      "#dcf0f9",
      "#b7e1f6",
      "#90d2f1",
      "#6ac3eb",
      "#42b4e2",
      "#16a4d5",
      "#0094c4",
      "#0084b2",
      "#00739e",
      "#00638a",
      "#005476",
      "#004461",
      "#00354d",
      "#002638",
      "#001623",
      "#00070d",
      "#000000"
    ],
    "success": [
      "#ffffff",
      "#e3f3dc",
      "#c6e8b8",
      "#a9dd94",
      "#8ed171",
      "#75c450",
      "#61b635",
      "#51a51f",
      "#429304",
      "#358100",
      "#2a7000",
      "#215f00",
      "#194d00",
      "#123c00",
      "#0b2b00",
      "#051a00",
      "#010900",
      "#000000"
    ],
    "warning": [
      "#ffffff",
      "#ffeada",
      "#ffd3b3",
      "#ffbd8d",
      "#ffa96b",
      "#ff9853",
      "#ec8640",
      "#d77531",
      "#c16523",
      "#aa5718",
      "#944a0f",
      "#7e3d09",
      "#673106",
      "#512504",
      "#3b1a03",
      "#250e02",
      "#0e0401",
      "#000000"
    ],
    "attention": [
      "#ffffff",
      "#ffeada",
      "#ffd3b3",
      "#ffbd8d",
      "#ffa96b",
      "#ff9853",
      "#ec8640",
      "#d77531",
      "#c16523",
      "#aa5718",
      "#944a0f",
      "#7e3d09",
      "#673106",
      "#512504",
      "#3b1a03",
      "#250e02",
      "#0e0401",
      "#000000"
    ],
    "error": [
      "#ffffff",
      "#fce7e4",
      "#fbcfca",
      "#f8b7b0",
      "#f59f96",
      "#ef877e",
      "#e86f67",
      "#de5852",
      "#d3403e",
      "#c5282c",
      "#b30a1b",
      "#9e000b",
      "#860001",
      "#6c0000",
      "#510000",
      "#340000",
      "#170000",
      "#000000"
    ],
    "danger": [
      "#ffffff",
      "#fce7e4",
      "#fbcfca",
      "#f8b7b0",
      "#f59f96",
      "#ef877e",
      "#e86f67",
      "#de5852",
      "#d3403e",
      "#c5282c",
      "#b30a1b",
      "#9e000b",
      "#860001",
      "#6c0000",
      "#510000",
      "#340000",
      "#170000",
      "#000000"
    ],
    "highlight": [
      "#ffffff",
      "#f9f5cd",
      "#f4eb95",
      "#efe05a",
      "#e6d427",
      "#d3c100",
      "#bfad00",
      "#ab9b00",
      "#988900",
      "#857700",
      "#736600",
      "#615600",
      "#4f4600",
      "#3e3600",
      "#2c2700",
      "#1b1700",
      "#090700",
      "#000000"
    ],
    "neutral": [
      "#ffffff",
      "#ededed",
      "#dbdbdb",
      "#cacaca",
      "#bababa",
      "#ababab",
      "#9b9b9b",
      "#8d8d8d",
      "#7e7e7e",
      "#707070",
      "#636363",
      "#565656",
      "#484848",
      "#383838",
      "#282828",
      "#181818",
      "#080808",
      "#000000"
    ]
  },
  baseTones: {
    highlight: 5,
    warning: 6,
    error: 8,
    danger: 8,
    secondary: 8,
    primary: 9,
    info: 8,
    success: 8,
    neutral: 8,
  },
  fontSizes: ["0.75rem", "0.875rem", "1rem", "1.25rem", "1.5625rem", "1.9375rem", "2.4375rem", "3.0625rem"],
  densities: [0.75, 1, 1.5, 2, 2.5],
  darkBias: 1,
  custom: {},
}

export default light
